import ReactSwitch from "react-switch";
import { commonConfirmBox } from "../../../helper/messagehelpers";
import { PdfSvg } from "../../../components/CommonSvg";
import { isPDF } from "../../../utils/generalUtils";

export const columns = (deleteNewsLetterRequest, dispatchData) => [
  {
    dataField: "documentPath",
    text: "Document",
    sort: true,
    formatter: (cell, row) => {
      return (
        <div className="table-img-box">
          {isPDF(row.documentPath) ? (
            <a href={row.documentPath} target="_ajay">
              <span className="docfile">
                <PdfSvg />
              </span>
            </a>
          ) : (
            <img width={80} src={row.documentPath} />
          )}
        </div>
      );
    },
  },
  {
    dataField: "title",
    text: "Title / Description",
    sort: true,
    formatter: (cell, row) => {
      return (
        <>
          <b>{row.title}</b>
          <p className="mb-0">{row.description}</p>
        </>
      );
    },
  },
  // {
  //   dataField: "description",
  //   text: "Description",
  //   sort: true,
  // },
  {
    dataField: "startDate",
    text: "Start Date",
    sort: true,
  },

  {
    dataField: "endDate",
    text: "End Date",
    sort: true,
  },
  {
    dataField: "isActive",
    text: "Status",
    headerClasses: "text-center",
    classes: "text-center",
    sort: true,
    formatter: (cell, row) => {
      return (
        <>
          <ReactSwitch
            className={`react-switch justify-content-center switch-sm ${
              row.isActive && "isActive"
            }`}
            onChange={async () => {
              const response = await commonConfirmBox(
                row.isActive
                  ? "Do you want to deactivate this Newsletter?"
                  : "Do you want to activate this Newsletter?",
                undefined,
                undefined
              );
              if (response) {
                deleteNewsLetterRequest({
                  newsletterId: row.id,
                  isActive: !row.isActive,
                  dispatchData,
                });
              }
            }}
            type="checkbox"
            id="custom-switch"
            checked={row.isActive}
          />
        </>
      );
    },
  },
  // {
  //     dataField: "status",
  //     text: "",
  //     classes: "text-center",
  //     formatter: (cell, row) => {
  //         return (
  //             <div className="action_col d-flex align-items-center justify-content-center">
  //                 <a
  //                     className="view_btn_icon mx-2"
  //                     title="View inquiry"
  //                     onClick={() => {
  //                         handleModalToggle();
  //                         setInquiryData(row);
  //                     }}
  //                 >
  //                     <ViewSvg />
  //                 </a>

  //                 <Link
  //                     className="delete_btn_icon mx-2"
  //                     title="Delete inquiry"
  //                     onClick={async () => {
  //                         const response = await commonConfirmBox(
  //                             "Are you sure you want to delete this inquiry?"
  //                         );
  //                         if (response) {
  //                             const deleteId = { inquiryId: row.id };
  //                             props.deleteInquiryReq({ deleteId, dispatchData });
  //                         }
  //                     }}
  //                 >
  //                     <DeleteSvg />
  //                 </Link>
  //             </div>
  //         );
  //     },
  // },
];
